import React from 'react';

export const injectHeader = (htmlHead: string) => {
  if (!htmlHead) return null;

  const scripts = htmlHead
    .split('\n')
    .filter(Boolean)
    .map((item) => item.split('"'));

  return scripts.reduce<JSX.Element[]>((acc, script) => {
    const url = script.find((x) => x.includes('http'));

    if (script.some((item) => item.includes('src'))) {
      acc.push(<script src={url} key={url} async={true} />);
    } else if (script.some((item) => item.includes('href'))) {
      acc.push(<link rel="preload" as="style" key={url + 'preload'} href={url} />);
      acc.push(<link rel="stylesheet" as="style" key={url + 'stylesheet'} href={url} />);
    }
    return acc;
  }, []);
};
